// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3reFj","footer":"ReportModalFilter_footer__xonpA"};